export default (exchangeRate) => ({
  base_url: '',
  locale: '',
  cruises: [],
  filter: {
    sort: null,
  },
  fetching: true,
  filteredCruises: [],

  filterCruises() {
    let ret = this.cruises;
    if (Object.keys(this.filter).length > 1) {
      if (this.filter.destinations && this.filter.destinations.length > 0) {
        ret = ret.filter((cruise) => {
          return this.filter.destinations.some((item) =>
            cruise.destination.destinations.includes(item)
          );
        });
      }
      if (this.filter.dates && this.filter.dates.length > 0) {
        ret = ret.filter((cruise) => {
          const date = new Date(cruise.sailing_date);
          return this.filter.dates.includes(
            `${date.getMonth() + 1}/${date.getFullYear()}`
          );
        });
      }
      if (this.filter.ships && this.filter.ships.length > 0) {
        ret = ret.filter((cruise) => {
          return this.filter.ships.includes(
            cruise.ship.ship_code.toLowerCase()
          );
        });
      }
      if (this.filter.ports && this.filter.ports.length > 0) {
        ret = ret.filter((cruise) => {
          if (!cruise.embarkation) {
            return false;
          }
          return this.filter.ports.includes(
            cruise.embarkation.port_code.toLowerCase()
          );
        });
      }
      if (this.filter.price && this.filter.price !== null) {
        ret = ret.filter((cruise) => {
          if (this.filter.price == 0 || this.filter.price == -1) {
            return true;
          } else {
            return cruise.standard_price <= this.filter.price * exchangeRate;
          }
        });
      }
    }

    if (Object.keys(this.filter).length !== 0) {
      ret = ret.sort((a, b) => {
        if (this.filter.sort === 'total_price:asc') {
          return a.standard_price - b.standard_price;
        } else if (this.filter.sort === 'total_price:desc') {
          return b.standard_price - a.standard_price;
        } else {
          return new Date(a.sailing_date) - new Date(b.sailing_date);
        }
      });
    }
    this.filteredCruises = ret;
  },

  init() {
    this.locale = document.documentElement.lang;

    this.base_url = `/api/collections/cruises/entries?filter[site]=${this.locale}&limit=1000&filter[archived]=false&filter[not_a_cruise]=false`;

    this.$watch('filter.sort', (value, oldValue) => {
      if (value !== oldValue) {
        this.filterCruises();
      }
    });

    const params = new URLSearchParams(window.location.search);
    const queryKeys = [
      'sort',
      'dates',
      'destinations',
      'ships',
      'price',
      'ports',
    ];
    let startFilter = false;

    queryKeys.forEach((key) => {
      if (params.has(key)) {
        this.filter[key] =
          key === 'dates' || key === 'destinations' || key === 'ships'
            ? params.get(key).split(',')
            : params.get(key);
        startFilter = true;
      }
    });

    if (startFilter) {
      this.$store.cruises.hideRenderedPagination = true;
    }

    fetch(this.base_url)
      .then((response) => response.json())
      .then((response) => {
        this.cruises = response.data;
        if (startFilter) {
          this.filterCruises();
        }
        this.fetching = false;
      });
  },
});
